import React, { useState } from "react";

export default function PasswordPrompt({ onSubmit }) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("入力パスワード:", input);

    try {
      // onSubmitは入力値を受け取り、true/falseを返す関数
      const isValid = await onSubmit(input);

      if (!isValid) {
        setError("パスワードが違います");
      }
    } catch (err) {
      console.error(err);
      setError("パスワード検証中にエラーが発生しました");
    }
  };

  return (
    <div className="password-prompt">
      <h2>このスレッドは保護されています</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="パスワードを入力"
        />
        <button type="submit">送信</button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}
